module.exports = __webpack_public_path__ + "static/media/upper_Skrvi_de.aee90863.mp4";